module.exports = __webpack_public_path__ + "img/analytics-blue.41736a8d.svg";